export default "<h1>Products</h1>\n\n<div class=\"table\">\n    <product-list [isAdmin]=\"true\"></product-list>\n</div>"